import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const User18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9 1.25C6.9575 1.25 5.25 2.9575 5.25 5C5.25 7.0425 6.9575 8.75 9 8.75C11.0425 8.75 12.75 7.0425 12.75 5C12.75 2.9575 11.0425 1.25 9 1.25ZM9 2.75C10.2255 2.75 11.25 3.7745 11.25 5C11.25 6.2255 10.2255 7.25 9 7.25C7.7745 7.25 6.75 6.2255 6.75 5C6.75 3.7745 7.7745 2.75 9 2.75Z'
      fill='currentColor'
    />
    <path
      d='M2.75 15C2.75 13.2051 4.20507 11.75 6 11.75H12C13.7949 11.75 15.25 13.2051 15.25 15V17H16.75V15C16.75 12.3766 14.6234 10.25 12 10.25H6C3.37665 10.25 1.25 12.3766 1.25 15V17H2.75V15Z'
      fill='currentColor'
    />
  </Svg>
);

User18.displayName = 'User18';
export default User18;
